/**
 * Google Tag Manager Configuration
 * Replace GTM-XXXXXXX with your actual GTM container ID
 */

export const GTM_CONFIG = {
  // Universal GTM container ID - works on all environments
  CONTAINER_ID: 'GTM-MHTZHFQV',
  
  // Universal settings - same for all environments
  DEBUG: true, // Enable debug mode for all environments to help with testing
  ENABLED: true, // Enable GTM on all environments including local
  
  // Event names for consistency
  EVENTS: {
    PAGE_VIEW: 'page_view',
    QUIZ_INTERACTION: 'quiz_interaction',
    FORM_INTERACTION: 'form_interaction',
    USER_ENGAGEMENT: 'user_engagement',
    CONVERSION: 'conversion',
    ERROR: 'error'
  },
  
  // Quiz-specific event types
  QUIZ_EVENTS: {
    QUIZ_STARTED: 'quiz_started',
    QUIZ_DATA_LOADED: 'quiz_data_loaded',
    QUESTION_ANSWERED: 'question_answered',
    CATEGORY_COMPLETED: 'category_completed',
    CATEGORY_NAVIGATION: 'category_navigation',
    QUIZ_SUBMISSION_CLICKED: 'quiz_submission_clicked',
    QUIZ_COMPLETED: 'quiz_completed'
  },
  
  // Form-specific event types
  FORM_EVENTS: {
    FIELD_INTERACTION: 'field_interaction',
    FORM_VALIDATION: 'form_validation',
    FORM_VALIDATION_SUCCESS: 'form_validation_success',
    FORM_VALIDATION_FAILED: 'form_validation_failed',
    FORM_SUBMISSION_ATTEMPT: 'form_submission_attempt',
    FORM_SUBMISSION_SUCCESS: 'form_submission_success',
    FORM_SUBMIT_BUTTON_CLICKED: 'form_submit_button_clicked'
  },
  
  // Error types
  ERROR_TYPES: {
    QUIZ_DATA_FETCH_ERROR: 'quiz_data_fetch_error',
    QUIZ_DATA_ERROR: 'quiz_data_error',
    QUIZ_SUBMISSION_ERROR: 'quiz_submission_error',
    NAVIGATION_ERROR: 'navigation_error'
  }
};

export default GTM_CONFIG;
